export enum FILTER_TYPES {
    CHIPS = 'tabbed',
    FULL_WIDTH = 'stacked'
}

export interface IFilterConfig {
    alwaysToggled: boolean;
    singleFilterToggle: boolean;
    showToggler: boolean;
    filtersAsCheckboxes: boolean;
    type: FILTER_TYPES;
    toggleOnHover?: boolean;
    allowAllFiltersCollapsed?: boolean;
}

export const tabbedFiltersConfig: IFilterConfig = {
    alwaysToggled: false,
    singleFilterToggle: true,
    showToggler: false,
    filtersAsCheckboxes: false,
    type: FILTER_TYPES.CHIPS
};

export const stackedFiltersConfig: IFilterConfig = {
    alwaysToggled: false,
    singleFilterToggle: true,
    showToggler: false,
    filtersAsCheckboxes: true,
    type: FILTER_TYPES.FULL_WIDTH,
    allowAllFiltersCollapsed: true
};

export const filtersConfig = {
    [FILTER_TYPES.CHIPS]: tabbedFiltersConfig,
    [FILTER_TYPES.FULL_WIDTH]: stackedFiltersConfig
};
